import {Component, computed, EventEmitter, Input, model, OnInit, Output, signal, WritableSignal} from '@angular/core';
import {AsignacionInterface, UsuarioAsignado} from 'src/app/officials/asignaciones/interfaces/asignacion-interface';
import {AsignacionesService} from 'src/app/officials/asignaciones/services/asignaciones.service';
import {Param} from 'src/app/shared/interfaces/param-interface';
import {PrimeNgModule} from 'src/app/shared/prime-ng/prime-ng.module';
import Swal from 'sweetalert2';
import {LoginServices} from 'src/app/auth/login/services/login.service';
import {CatalogoInterface, ProyectoItem} from 'src/app/users/interfaces/proyecto.interface';
import {LoaderSpinnerComponent} from "src/app/shared/components/loader-spinner/loader-spinner.component";
import {AsignacionesDataService} from 'src/app/officials/asignaciones/services/asignaciones-data.service';
import {ProyectoDataService} from 'src/app/users/proyectos/services/proyecto-data.service';

@Component({
    selector: 'app-dialog-asignar-profesionales',
    standalone: true,
    imports: [PrimeNgModule, LoaderSpinnerComponent],
    templateUrl: './dialog-asignar-profesionales.component.html',
    styleUrl: './dialog-asignar-profesionales.component.scss'
})
export class DialogAsignarProfesionalesComponent implements OnInit {
    @Input() visible: boolean = false;
    @Input() selectedProyectos = signal<ProyectoItem[]>([]);
    @Output() visibleChange = new EventEmitter<boolean>();

    private _users: WritableSignal<UsuarioAsignado[]> = signal([]);
    selectedProyecto: WritableSignal<ProyectoItem | null> = signal(null);
    tecnicosAsignados = signal<UsuarioAsignado | null>(null);
    selectedCategoria: WritableSignal<CatalogoInterface | null> = model(null);
    selectedCount = computed(() => this.selectedProyectos().length);

    isLoading = signal(false);

    constructor(public asignacionesService: AsignacionesService, protected ls: LoginServices, public asignacionesDataService: AsignacionesDataService,
                public pds: ProyectoDataService
    ) {
    }

    ngOnInit(): void {
        this.consultarEmpleados();
    }

    private consultarEmpleados() {
        const params: Param[] = [{key: "tipo", value: "2"}, {
            key: "rol",
            value: 'atencion.cliente, tecnico_resolutor, tecnico.registro'
        }];
        this.asignacionesService.consultaTodos(params)
            .subscribe({
                next: (result) => {
                    this._users.set(result.body!)
                },
                error: (error) => {
                    console.log(error)
                }
            });
    }

    private sincronizarDatos() {
        this.asignacionesDataService.q1resumenGlobalDeEstados(true);
        this.pds.consultarPorTipoDeSolicitud('3')
    }

    procesarAsignacion(p_asignar: boolean) {
        console.log("tecnicoAsignados->", this.tecnicosAsignados())
        console.log("PROYECTOS SELECCIONADOS", this.selectedProyectos());
        const asignaciones: AsignacionInterface[] = [];
        const proyectos = this.selectedProyectos();
        const tecnico = this.tecnicosAsignados();
        this.visible = false;
        Swal.fire({
            title: "¿Estas seguro?",
            text: "Esta acción no se puede revertir",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Si, asignar solicitud/es",
            customClass: {
                popup: 'swal-override-zindex'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                if (tecnico) {
                    for (const proyecto of proyectos) {
                        const item: AsignacionInterface = {
                            idProyecto: proyecto.idProyecto.toString(),
                            uniqueIdUsuarioAsigna: this.ls.session()?.perfil?.uniqueId,
                            uniqueIdUsuario: tecnico.uniqueId,
                            numeroExpediente: proyecto.numeroExpediente,
                            idSolicitud: proyecto.idSolicitud?.toString(),
                            asignar: p_asignar,
                            idTipoRevision: 3
                        };
                        asignaciones.push(item);
                    }
                }
                this.isLoading.set(true);
                this.asignacionesService.asignarSolicitudes(asignaciones)
                    .subscribe({
                        next: (result) => {
                            this.isLoading.set(false);
                            this.visible = false;
                            if (result.status == 200 || result.status == 201) {
                                Swal.fire({
                                    icon: "success",
                                    title: "Éxito",
                                    text: 'Solicitudes de Registro Profesional, asignadas correctamente',
                                    showDenyButton: true,
                                    showConfirmButton: false,
                                    denyButtonText: `Ok`
                                });
                            }
                            this.sincronizarDatos();
                            this.selectedProyectos.set([]);
                        },
                        error: (error) => {
                            this.isLoading.set(false);
                            this.visible = false;
                            Swal.fire({
                                icon: "error",
                                title: "Error",
                                text: 'Ocurrió un error al procesar',
                                showDenyButton: true,
                                showConfirmButton: false,
                                denyButtonText: `Ok`
                            });
                            console.log(error)
                            this.selectedProyectos.set([]);
                        },
                        complete: () => {
                            this.isLoading.set(false);
                            this.selectedProyectos.set([]);
                        }
                    });
            }
        });


    }

    onClose() {
        this.visible = false;
        this.visibleChange.emit(false);
    }

    get users(): WritableSignal<UsuarioAsignado[]> {
        return this._users;
    }

    set users(value: WritableSignal<UsuarioAsignado[]>) {
        this._users = value;
    }
}
